var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestrictedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#FFB655"
    },
    d: "M411.151,201.697h-23.273h-46.545h-85.332h-85.335h-46.545h-23.273 c-12.853,0-23.273,10.42-23.273,23.273v263.758c0,12.853,10.42,23.273,23.273,23.273h155.153h155.15 c12.853,0,23.273-10.42,23.273-23.273V224.97C434.424,212.117,424.004,201.697,411.151,201.697z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#FFB655"
    },
    d: "M411.151,201.697h-23.273h-46.545h-85.332h-85.335h-46.545h-23.273 c-12.853,0-23.273,10.42-23.273,23.273v263.758c0,12.853,10.42,23.273,23.273,23.273h155.153h155.15 c12.853,0,23.273-10.42,23.273-23.273V224.97C434.424,212.117,424.004,201.697,411.151,201.697z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77757F"
    },
    d: "M294.738,331.582c-0.061-1.171-0.18-2.326-0.343-3.468c-0.135-0.957-0.306-1.904-0.51-2.838 c-3.263-14.901-15.106-26.629-30.078-29.701c-0.085-0.017-0.171-0.029-0.258-0.047c-1.809-0.358-3.663-0.596-5.556-0.692 c-0.393-0.02-0.79-0.022-1.184-0.031c-0.27-0.005-0.538-0.02-0.808-0.02c0,0,0,0-0.002,0c-21.388,0-38.788,17.4-38.788,38.788 c0,12.663,6.102,23.926,15.515,31.009v31.054c0,12.853,10.42,23.273,23.273,23.273c0.002,0,0.002,0,0.002,0 c0.563,0,1.116-0.045,1.669-0.084c0.234-0.017,0.476-0.012,0.709-0.036c0.334-0.034,0.658-0.102,0.987-0.15 c11.253-1.635,19.906-11.295,19.906-23.001v-31.052c9.413-7.083,15.515-18.347,15.515-31.009 C294.788,332.907,294.771,332.243,294.738,331.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C3C7"
    },
    d: "M170.667,131.877c0-47.051,38.281-85.332,85.333-85.332s85.333,38.281,85.333,85.332v69.82h46.545 v-69.82C387.879,59.161,328.718,0,256,0S124.121,59.161,124.121,131.877v69.82h46.545V131.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57575C"
    },
    d: "M256.002,294.788c0,0,0,0-0.002,0c-21.388,0-38.788,17.4-38.788,38.788 c0,12.663,6.102,23.926,15.515,31.009v31.052c0,12.853,10.42,23.273,23.273,23.273c0.002,0,0.002,0,0.002,0V294.788z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1CB30"
    },
    d: "M258.38,418.788c-0.233,0.023-0.475,0.02-0.709,0.036 C257.907,418.808,258.147,418.813,258.38,418.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1CB30"
    },
    d: "M259.367,418.638c11.253-1.635,19.906-11.295,19.906-23.001 C279.273,407.343,270.62,417.004,259.367,418.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1CB30"
    },
    d: "M293.885,325.278c0.205,0.934,0.375,1.879,0.51,2.838 C294.26,327.157,294.09,326.212,293.885,325.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1CB30"
    },
    d: "M256.811,294.808c0.394,0.008,0.791,0.009,1.184,0.031 C257.601,294.819,257.204,294.817,256.811,294.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1CB30"
    },
    d: "M263.55,295.531c0.087,0.017,0.172,0.029,0.258,0.047 C263.722,295.561,263.637,295.548,263.55,295.531z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M100.848,512h155.153v-93.091c0,0,0,0-0.002,0c-12.853,0-23.273-10.42-23.273-23.273v-31.052 c-9.413-7.083-15.515-18.347-15.515-31.009c0-21.388,17.4-38.788,38.788-38.788c0.002,0,0.002,0,0.002,0v-93.091h-85.335h-46.545 h-23.273c-12.853,0-23.273,10.42-23.273,23.273v263.758C77.576,501.58,87.996,512,100.848,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9A8AE"
    },
    d: "M124.121,131.879v69.818h46.545v-69.818c0-47.053,38.281-85.333,85.333-85.333V0 C183.282,0,124.121,59.161,124.121,131.879z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedIcon);
export default __webpack_public_path__ + "static/media/restricted-icon.add6c821.svg";
export { ForwardRef as ReactComponent };